import { render, staticRenderFns } from "./ThirdPartyTransactionDetail.vue?vue&type=template&id=2bccede9&scoped=true"
import script from "./ThirdPartyTransactionDetail.vue?vue&type=script&lang=js"
export * from "./ThirdPartyTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyTransactionDetail.vue?vue&type=style&index=0&id=2bccede9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bccede9",
  null
  
)

export default component.exports